import React from "react";
import moment from "moment";
import css from "./DayScheduleView.scss";
import {SFVirtualCheckInDaySchedule} from "utils/types";
import {tenantTimeFormat} from "utils/time";

function renderSlot(slot, key) {
    return (
        <span className={css['slot']} key={key}>
                {moment(slot.openTime, "hh:mm").format(tenantTimeFormat('timeDisplayFormat')) + ' - '
                + moment(slot.closeTime, "hh:mm").format(tenantTimeFormat('timeDisplayFormat'))}
        </span>
    );
}

export default function DayScheduleView({day}) {
    return (
        <div className={css['day']}>
            <div className={css['weekday']}>{moment().day(day.dayOfWeek).format("dd")}</div>
            <div className={css['slots']}>{day.timeSlots.map((slots, key) => renderSlot(slots, day.dayOfWeek + key))}</div>
        </div>
    );
}

DayScheduleView.propTypes = {
    day: SFVirtualCheckInDaySchedule.isRequired
}
